"use client";

import { useCallback } from "react";
import { getAttribution } from "@/lib/attribution";
import { createAnalyticsEvent } from "@/lib/analytics/track";
import { trackEvent as trackGa4Event } from "@/lib/analytics/ga4";

function toGa4Params(properties: Record<string, unknown>) {
  return Object.fromEntries(
    Object.entries(properties).filter((entry): entry is [string, string | number | boolean | null | undefined] => {
      const value = entry[1];
      return (
        value === null ||
        value === undefined ||
        typeof value === "string" ||
        typeof value === "number" ||
        typeof value === "boolean"
      );
    }),
  );
}

type TrackEventOptions = {
  includeAttribution?: boolean;
};

export function useTrackEvent({ includeAttribution = true }: TrackEventOptions = {}) {
  return useCallback((name: string, properties?: Record<string, unknown>) => {
    if (typeof window === "undefined") return;
    const attribution = includeAttribution ? getAttribution() : {};
    const event = createAnalyticsEvent(name, {
      ...attribution,
      ...properties,
    });
    const payload = includeAttribution ? event.properties : { ...(properties ?? {}) };
    trackGa4Event(name, toGa4Params(payload));
  }, [includeAttribution]);
}
